module.exports = {"411621001":"桐丘街道","411621003":"扶亭街道","411621101":"崔桥镇","411621102":"江村镇","411621103":"白潭镇","411621104":"韭园镇","411621105":"练寺镇","411621106":"大新镇","411621107":"包屯镇","411621108":"汴岗镇","411621200":"曹里乡","411621201":"柴岗乡","411621202":"固城乡","411621203":"吕潭乡","411621204":"大李庄乡","411621205":"城郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411621.json
// module id = 1799
// module chunks = 0